import CreateConnection from "../components/create-connection"

export default function CreateReferralPage() {
  return <CreateConnection />;
}
